import { useAppBridge } from "@shopify/app-bridge-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_URL } from "../../config";

export const useInstallOnShop = () => {
  const appBridge = useAppBridge();
  const queryClient = useQueryClient();
  const query = useMutation({
    mutationKey: ["install", appBridge.config.shop],
    mutationFn: async () => {
      const res = await fetch(`${API_BASE_URL}/install`, {
        headers: {
          Authorization: `Bearer ${await appBridge.idToken()}`,
        },
        method: "POST",
      });
      return res.ok;
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ["installed", appBridge.config.shop],
      });
    },
  });

  return query;
};
